import React, { createContext, ReactNode } from 'react';
import RootStore from './RootStore';

export const StoreContext = createContext<RootStore | undefined>(undefined);

interface StoreProviderProps {
  children: ReactNode;
  store: RootStore;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, store }) => (
  <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
);
